import { ArrowRight } from 'lucide-react';
import type { HandoffMessage } from '@vagusx/clients';
import { cn } from '@/lib/utils';

/**
 * Inline handoff marker in the transcript stream. Rendered as a
 * centered separator with arrow: `from — → — to`, with the carried
 * `firstMessage` underneath if present.
 *
 * Intentionally understated — handoffs are invisible to the patient
 * on the call; they're a mechanism detail. Showing them in the
 * transcript is for post-call review.
 */
export function HandoffRow({ event }: { event: HandoffMessage }): React.ReactElement {
  const { fromAgentId, toAgentId, firstMessage } = event.payload;
  return (
    <div className="my-2 flex flex-col items-center gap-1 text-xs text-muted-foreground">
      <div className="flex items-center gap-2">
        <span className={cn('h-px flex-1 bg-border', 'w-16')} />
        <span className="font-mono">
          {fromAgentId ?? 'start'} <ArrowRight className="inline h-3 w-3" /> {toAgentId}
        </span>
        <span className={cn('h-px flex-1 bg-border', 'w-16')} />
      </div>
      {firstMessage && <div className="italic opacity-70">&ldquo;{firstMessage}&rdquo;</div>}
    </div>
  );
}
